import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import Button from '../../../elements/Button';
import Icon from '../../../elements/Icon';
import Box from '../../../elements/Box';

const ActionButton = ({
  buttonsHeight,
  showArrowsWhenDisabled,
  disabled,
  settings,
  labelKey,
  left,
  right,
  onArrowClick,
  dataTestId
}) => {
  const { translate } = React.useContext(Context);

  const handleKeyDown = ($event) => {
    if ($event.keyCode === 13 || $event.keyCode === 32) {
      onArrowClick($event, true);
    }
  };

  return (
    <Box
      position="absolute"
      cmp-styles={buttonsHeight}
      top="0"
      left={left}
      right={right}
      className="slick-arrow"
    >
      <Box display="flex" height="100" alignItems="center">
        {((showArrowsWhenDisabled && disabled) || !disabled) && (
          <Button
            dataTestId={dataTestId}
            disabled={disabled}
            {...settings}
            ariaLabel={translate(labelKey, labelKey)}
            onClick={onArrowClick}
            onKeyDown={handleKeyDown}
          >
            <Icon align="middle" rotate {...settings.iconProps} />
          </Button>
        )}
      </Box>
    </Box>
  );
};

ActionButton.propTypes = {
  buttonsHeight: PropTypes.objectOf(PropTypes.any),
  showArrowsWhenDisabled: PropTypes.bool,
  disabled: PropTypes.bool,
  settings: PropTypes.objectOf(PropTypes.any),
  labelKey: PropTypes.string.isRequired,
  left: PropTypes.string,
  right: PropTypes.string,
  dataTestId: PropTypes.string,
  onArrowClick: PropTypes.func
};

ActionButton.defaultProps = {
  buttonsHeight: {},
  showArrowsWhenDisabled: true,
  disabled: false,
  settings: {},
  left: null,
  right: null,
  dataTestId: null,
  onArrowClick: () => {}
};

export default ActionButton;
